import { Injectable } from '@angular/core';
import { MessageService } from '../service-ui/message.service';
import { HttpClient} from '@angular/common/http';
import { StartupService } from '../service-ui/startup.service';
import {NotificationsService} from "./notifications.service";
import {AbstractLiveDataService} from "./abstract-live-data.service";
import {EcommerceOrder} from "../../model/EcommerceOrder";
import {Observable, of} from "rxjs";
import {ManufacturingResourceBucketPeriod} from "../../model/ManufacturingResourceBucketPeriod";
import {environment} from "../../environments/environment";
import {catchError, tap} from "rxjs/operators";
import {ManufacturingResouceBucketPeriodCapacity} from "./manufacturing-resource-bucket-period.service";

@Injectable()
export class EcommerceOrderService extends AbstractLiveDataService<EcommerceOrder> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    notificationsService.setEcommerceOrderService(this);
    notificationsService.startNotification();
  }

  makeObjectInstance(args: any): EcommerceOrder {
    return new EcommerceOrder(args);
  }

  getLoggingObjectTypeName (): string {
    return "EcommerceOrder";
  }

  supportsParallel(): boolean {
    return true;
  }

  getURLEndPoint (): string {
    return "ecommerceorder";
  }

  // private handleErrorX<T> (role: string, operation = 'operation', result?: T) {
  //   return (error: any): Observable<T> => {
  //     this.loadingState[role] = 'INITIAL';
  //
  //     // TODO: send the error to remote logging infrastructure
  //     console.error(error, operation); // log to console instead
  //
  //     // TODO: better job of transforming error for user consumption
  //     this.log(`${operation} failed: ${error.message}`);
  //
  //     // Let the app keep running by returning an empty result.
  //     return of(result as T);
  //   };
  // }


  getLinkData(): any[] {
    return [
      { action: 'Link', objectIdPropertyName: 'ecommerceconnection_ID', serviceName: 'ecommerceConnectionService', arrayProperty: 'ecommerceProducts', objectProperty: 'ecommerceConnection'},
      { action: 'Link', objectIdPropertyName: 'product_ID', serviceName: 'productService', arrayProperty: 'ecommerceProducts', objectProperty: 'product'},
    ];
  }
      // { action: 'Link', objectIdPropertyName: 'org_ID', serviceName: 'organizationService', arrayProperty: 'ecommerceOrders', objectProperty: 'organization'},

  create(ecommerceOrder: EcommerceOrder): Observable<EcommerceOrder> {
    const url = `${environment.apiBaseURL}${this.getURLEndPoint()}`;
    this.messageService.add(`create EcommerceOrderService ${JSON.stringify(ecommerceOrder)}`);
    return this.http.post(url, ecommerceOrder, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`create EcommerceOrderService ${JSON.stringify(ecommerceOrder)}`)),
      catchError(this.handleErrorX<any>(`error create EcommerceOrderService ${JSON.stringify(ecommerceOrder)}}`))
    );
  }

  compute (ecommerceOrder: EcommerceOrder): Observable<EcommerceOrder> {
    const url = `${environment.apiBaseURL}/${this.getURLEndPoint()}/compute`;
    this.messageService.add(`compute EcommerceOrderService ${JSON.stringify(ecommerceOrder)}`);
    return this.http.put(url, ecommerceOrder, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`compute EcommerceOrderService ${JSON.stringify(ecommerceOrder)}`)),
      catchError(this.handleErrorX<any>(`error compute EcommerceOrderService ${JSON.stringify(ecommerceOrder)}}`))
    );
  }

  release (ecommerceOrder: EcommerceOrder): Observable<EcommerceOrder> {
    const url = `${environment.apiBaseURL}/${this.getURLEndPoint()}/release`;
    this.messageService.add(`release EcommerceOrderService ${JSON.stringify(ecommerceOrder)}`);
    return this.http.put(url, ecommerceOrder, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`release EcommerceOrderService ${JSON.stringify(ecommerceOrder)}`)),
      catchError(this.handleErrorX<any>(`error release EcommerceOrderService ${JSON.stringify(ecommerceOrder)}}`))
    );
  }

  /**
   * Re-push the order-completion message (fulfilment + tracking numbers) to the
   * remote ecommerce platform.
   *
   * This is a RETRY of something the server already attempts automatically when
   * the last PrintNodeOrder ships, so it is only offered from the UI when every
   * PrintNodeOrder on the order is SHIPPED. The server is expected to report the
   * outcome by updating `EcommerceOrder.shipmentUpdateStatus` (and to push that
   * change over the notification pipeline), so the caller does not need to do
   * anything with the response body beyond clearing its spinner.
   *
   * The all-shipped rule is enforced server-side too (HTTP 409 with the reasons
   * in `warnings[]`), so the client guard is a convenience and not a control.
   *
   * NOTE: `handleErrorX` is deliberately NOT applied here. It swallows the
   * HttpErrorResponse and returns `undefined`, which would hide the 409 and its
   * `warnings[]` from the caller -- the same reasoning as
   * `PrintNodeOrderService.split()`. The component needs the status code and
   * the warnings to tell the user why the resend was refused.
   *
   * Endpoint confirmed in
   * docs/contracts/inbox/_processed/2026-09-11-ecommerce-order-shipment-update-status-answers.md
   */
  resendShipmentUpdate (ecommerceOrder: EcommerceOrder): Observable<any> {
    const url = `${environment.apiBaseURL}/${this.getURLEndPoint()}/resendshipmentupdate/${ecommerceOrder.ID}`;
    this.messageService.add(`resendShipmentUpdate EcommerceOrderService ${ecommerceOrder.ID}`);
    return this.http.put(url, {}, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`resendShipmentUpdate EcommerceOrderService ${ecommerceOrder.ID}`))
    );
  }


  private handleErrorX<T> (role: string, operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error, operation); // log to console instead
      this.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  // private handleErrorX<EcommerceOrder> (message: string, ecommerceOrder: EcommerceOrder): Observable<EcommerceOrder> {
  //   return (error: any): Observable<EcommerceOrder> => {
  //     this.loadingState = 'INITIAL';
  //
  //     // TODO: send the error to remote logging infrastructure
  //     console.error(error, message); // log to console instead
  //
  //     // TODO: better job of transforming error for user consumption
  //     this.log(`${message} failed: ${error.message}`);
  //
  //     // Let the app keep running by returning an empty result.
  //     return of(result as EcommerceOrder);
  //   };
  // }

  // private handleErrorX<EcommerceOrder> (updateCapacities1: string) {
  //   return function (p1: any, p2: Observable<any>) {
  //     return undefined;
  //   };
  // }
}
